"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchResubscribeSubscriptionEmail = exports.fetchOptinSubscriptionEmail = exports.fetchOptinFollowupSubscriptionEmail = void 0;

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchOptinFollowupSubscriptionEmail = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getOptinFollowupEmail,
  initiatingActionType: _actions.SubscriptionEmailsActionTypes.FETCH_OPTIN_FOLLOWUP_EMAIL,
  requestStatusSelector: _selectors.getFetchOptinFollowupEmailRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchOptinFollowupEmail
}));
exports.fetchOptinFollowupSubscriptionEmail = fetchOptinFollowupSubscriptionEmail;
var fetchOptinSubscriptionEmail = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getOptinEmail,
  initiatingActionType: _actions.SubscriptionEmailsActionTypes.FETCH_OPTIN_EMAIL,
  requestStatusSelector: _selectors.getFetchOptinEmailRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchOptinEmail
}));
exports.fetchOptinSubscriptionEmail = fetchOptinSubscriptionEmail;
var fetchResubscribeSubscriptionEmail = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getResubscribeEmail,
  initiatingActionType: _actions.SubscriptionEmailsActionTypes.FETCH_RESUBSCRIBE_EMAIL,
  requestStatusSelector: _selectors.getFetchResubscribeEmailRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchResubscribeEmail
}));
exports.fetchResubscribeSubscriptionEmail = fetchResubscribeSubscriptionEmail;